import { render, staticRenderFns } from "./BaseAutoComp.vue?vue&type=template&id=66ad12bc"
import script from "./BaseAutoComp.vue?vue&type=script&lang=js"
export * from "./BaseAutoComp.vue?vue&type=script&lang=js"
import style0 from "./BaseAutoComp.vue?vue&type=style&index=0&id=66ad12bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports